import { useContext } from 'react'

import { BadgeEarnedPopupContext } from '@percent/workplace-giving/context/badgeEarnedPopup/badgeEarnedPopupContext/BadgeEarnedPopupContext'

export const useBadgeEarnedPopup = () => {
  const context = useContext(BadgeEarnedPopupContext)

  if (context === undefined) {
    throw new Error('useBadgeEarnedPopup must be used within an BadgeEarnedPopupContextController')
  }

  return context
}
